import { render } from "./SystemInbound.vue?vue&type=template&id=7df566b0&scoped=true"
import script from "./SystemInbound.vue?vue&type=script&lang=js"
export * from "./SystemInbound.vue?vue&type=script&lang=js"

import "./SystemInbound.vue?vue&type=style&index=0&id=7df566b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df566b0"]])

export default __exports__